import React from "react";
import Skeleton from "react-loading-skeleton";

const MessageLoading = () => {
  return (
    <>
      <div className="msg-item">
        <div className={`message-sender reply_on_msg`}>
          <div className="msg-avatar">
            <Skeleton />
          </div>
          <div className="msg-content reply-content w-100">
            <div className="msg-header">
              <div className="title w-100 px-2">
                <Skeleton className="msg-name" containerClassName="w-100" />
              </div>
            </div>

            <div className="msg-body">
              <Skeleton count={4.5} containerClassName="w-100" />
            </div>
          </div>
        </div>
      </div>
      <div className={`unique_message_box msg-item`}>
        <div className={`message-sender reply_on_msg w-100 `}>
          <div className="msg-body bg-light">
            <Skeleton count={4.5} containerClassName="w-100" />
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageLoading;
